import { FC } from 'react'
import { Box, styled } from '@mui/material'
import { useTranslation } from 'react-i18next'
import moment from 'moment'
import { isNilOrEmpty } from 'packages/core'
import { MUIDateTimePicker } from 'packages/eid-ui/DateTimePickers'

export interface EndDateTimePickerProps {
    selectedEndDate: any
    setSelectedEndDate: any
    minEndDate?: any
    maxEndDate?: any
    hasInvalidDates: any
    validationMessage: any
    disabled?: boolean
    label?: string
}

const PolicyViolationMessage = styled(Box)(({ theme }) => ({
    position: 'absolute',
    fontSize: '1.2rem',
    color: theme.palette.error.main,
    marginRight: '1.2rem',
    wordBreak: 'break-word',
}))

export const EndDateTimePicker: FC<EndDateTimePickerProps> = ({
    selectedEndDate,
    setSelectedEndDate,
    minEndDate,
    maxEndDate,
    hasInvalidDates,
    validationMessage,
    disabled = false,
    label = 'EndDateTime',
}) => {
    const { t } = useTranslation()

    return (
        <>
            <MUIDateTimePicker
                dateTimeFormat="L LT"
                disabled={disabled}
                minDate={minEndDate ? minEndDate : moment(new Date())}
                maxDate={maxEndDate}
                value={selectedEndDate ? moment(selectedEndDate) : null}
                handleChange={(e: any) => {
                    if (isNilOrEmpty(e)) {
                        setSelectedEndDate(moment().utc().format())
                    } else if (
                        maxEndDate &&
                        moment(e).isAfter(moment(maxEndDate))
                    ) {
                        setSelectedEndDate(moment(maxEndDate).utc().format())
                    } else {
                        const date = moment(e)
                        const dateToSet = date.clone().utc().format()
                        setSelectedEndDate(dateToSet)
                    }
                }}
                label={t(label)}
            />

            {hasInvalidDates && validationMessage && (
                <PolicyViolationMessage>
                    {validationMessage}
                </PolicyViolationMessage>
            )}
        </>
    )
}
